import SolidSpinnerIcon from "../../assets/icons/SolidSpinnerIcon";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import React from "react";

const AlertOverlay = ({
  isLoading,
  handleContinue,
  children,
  title,
  description,
  isAlertOverlayOpen,
  setIsAlertOverlayOpen,
}) => {
  return (
    <AlertDialog open={isAlertOverlayOpen} onOpenChange={setIsAlertOverlayOpen}>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent className="bg-zinc-900 border-zinc-800">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-transparent border-none hover:bg-zinc-800 hover:text-zinc-100">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            className="bg-zinc-100 hover:bg-zinc-50 text-zinc-800 flex gap-1"
            onClick={handleContinue}
          >
            {isLoading ? (
              <div>
                <SolidSpinnerIcon className="w-4 h-4 animate-spin" />
              </div>
            ) : null}
            <div>Continue</div>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AlertOverlay;
